// /* eslint-disable @typescript-eslint/no-unused-expressions */

// /* eslint-disable array-callback-return */
// import * as React from "react";
// import { withTranslation } from "react-i18next";
// import i18n from "../i18n";
// import { DataService } from "../services/DataService";
// import ExpectedReportsBarChart from "../components/DashboardComps/ExpectedReportsBarChart";
// import { Spinner, Stack } from "react-bootstrap";
// import {
//   ICategoryForPieChart,
//   IDashboardCategorys,
//   IDashboardExpectedReports,
//   //IDashboardLEV_SinfraContractArea,
//   IData_fordashboardCard,
//   IInvoiceDataForPieChart,
// } from "../services/API/DashBoard";
// import PieChartCategorys from "../components/DashboardComps/PieChartCategorys";
// import Card from "../components/DashboardComps/Card";
// import {
//   SvgForKickbackReports,
//   SvgForNullReports,
//   SvgForStatisticReports,
// } from "../components/DashboardComps/SvgIcons";
// import CategoryModal from "../components/DashboardComps/CategoryModal";
// import ViewCard from "../components/DashboardComps/ViewCard";
// import { FloorTo, RoundTo } from "../lib/utils";
// import CalendarYearPie from "../components/DashboardComps/CalendarYearPie";

// interface IDashboardProps {}
// interface IDashboardState {
//   loading: boolean;
//   loadingCards: boolean;
//   expectedReports: IDashboardExpectedReports[];
//   categorys: IDashboardCategorys;
//   //perContract: IDashboardLEV_SinfraContractArea[];
//   period: string;
//   statistikRapporterCard: IData_fordashboardCard[];
//   nollRapporterCard: IData_fordashboardCard[];
//   kickbackRapporterCard: IData_fordashboardCard[];
//   periodIndex: number;
//   yearFilter: string[];
//   showCategoryModal: boolean;
//   dataForCategoryModal: any[];
//   summedDataForPie: IInvoiceDataForPieChart[];
//   dataForPie: ICategoryForPieChart[];
//   selectedCategory: string;
//   filterdByYear: any[];
//   aggregatedYear:AggregatedYear[]
// }
// type PeriodRow = {
//   period: string; // "YYYY-MM"
//   reportsExpected: number;
//   reportsReceived: number;
//   invoiceReports: number;
//   nullReports: number;
//   csrdReports: number;
// };

// type AggregatedYear = {
//   academicYearKey: string;   // t.ex. "2021-09_2022-08" (intern nyckel)
//   label: string;             // t.ex. "2021/2022" – bra för diagram
//   reportsExpected: number;
//   reportsReceived: number;
// };
// function getAcademicYearKey(period: string, startMonth = 9): { key: string; label: string } {
//   // period: "YYYY-MM"
//   const [yearStr, monthStr] = period.split("-");
//   const year = parseInt(yearStr, 10);
//   const month = parseInt(monthStr, 10);

//   if (Number.isNaN(year) || Number.isNaN(month)) {
//     throw new Error(`Ogiltig period: ${period}`);
//   }

//   // Ex: startMonth = 9 (september)
//   // Sep–Dec => startar samma år
//   // Jan–Aug => tillhör året som startade året innan
//   const startYear = month >= startMonth ? year : year - 1;
//   const endYear = startYear + 1;

//   return {
//     key: `${startYear}-${String(startMonth).padStart(2, "0")}_${endYear}-08`, // t.ex. "2021-09_2022-08"
//     label: `${startYear}/${endYear}`,                                         // t.ex. "2021/2022"
//   };
// }
// function aggregateByAcademicYear(data: PeriodRow[], startMonth = 9): AggregatedYear[] {
//   const map = new Map<string, AggregatedYear>();

//   for (const row of data) {
//     const { key, label } = getAcademicYearKey(row.period, startMonth);

//     if (!map.has(key)) {
//       map.set(key, {
//         academicYearKey: key,
//         label,
//         reportsExpected: 0,
//         reportsReceived: 0,
//       });
//     }

//     const agg = map.get(key)!;
//     agg.reportsExpected += row.reportsExpected;
//     agg.reportsReceived += row.reportsReceived;
//   }

//   // Sortera på start-året i kronologisk ordning
//   const result = Array.from(map.values()).sort((a, b) => {
//     const aStartYear = parseInt(a.label.split("/")[0], 10);
//     const bStartYear = parseInt(b.label.split("/")[0], 10);
//     return aStartYear - bStartYear;
//   });

//   return result;
// }

// class Dashboard extends React.Component<IDashboardProps, IDashboardState> {
//   constructor(props: IDashboardProps) {
//     super(props);
//     this.state = {
//       expectedReports: [],
//       categorys: {} as IDashboardCategorys,
//       period: "",
//       //perContract: [] as IDashboardLEV_SinfraContractArea[],
//       statistikRapporterCard: [] as IData_fordashboardCard[],
//       nollRapporterCard: [] as IData_fordashboardCard[],
//       kickbackRapporterCard: [] as IData_fordashboardCard[],
//       loading: true,
//       periodIndex: -1,
//       yearFilter: [""],
//       showCategoryModal: false,
//       dataForCategoryModal: [],
//       loadingCards: true,
//       dataForPie: [] as ICategoryForPieChart[],
//       summedDataForPie: [] as IInvoiceDataForPieChart[],
//       selectedCategory: "",
//       filterdByYear: [],
//       aggregatedYear:[]
//     };
//   }
//   async componentDidMount(): Promise<void> {
//     const [
//       categorys,
//       //perContract,
//       summedDataForPie,
//       expectedReports
//     ] = await Promise.all([
//       DataService.Dashboard.GetCategorys(),
//       //DataService.Dashboard.GetLEV_SinfraContractArea(),
//       DataService.Dashboard.GetData_IInvoiceDataForPieChart(),
//       DataService.Dashboard.GetExpectedReports()
//     ]);
   
//     await this.InitCards();
//     await this.InitBarChart(expectedReports);
//    const res =  aggregateByAcademicYear(expectedReports);
//     const date = new Date();
//     const backUpYeah = new Date(date.getFullYear(),date.getMonth()-1)
//     const formatted = backUpYeah.toLocaleDateString('sv-SE').split('-')
//     const period = `${formatted[0]}-${formatted[1]}`;
//     this.setState({
//       categorys,
//       //perContract,
//       period,
//       summedDataForPie,
//       expectedReports,
//       aggregatedYear:res
//     },() => this.InitBarChart(this.state.expectedReports));
//   }
//   InitBarChart = async (expectedReports:IDashboardExpectedReports[]) => {
   
//     const yearFilter = this.CreateYearFilter(expectedReports);
//     this.FilterByYear(yearFilter.length);
//     this.setState({
      
//       yearFilter,
//       periodIndex: yearFilter.length,
//     });
//   };
//   InitCards = async () => {
//     const cardData = await DataService.Dashboard.GetData_fordashboardCard();
//     this.setState({
//       loadingCards: false,
//       statistikRapporterCard: cardData[0],
//       nollRapporterCard: cardData[1],
//       kickbackRapporterCard: cardData[2],
//     });
//   };
//   CreateYearFilter = (
//     expectedReports: IDashboardExpectedReports[]
//   ): string[] => {
//     const periods: Set<string> = new Set();
//     expectedReports.map((x) =>
//       periods.add(new Date(x.period).getFullYear().toString())
//     );
//     const parsedPeriods: string[] = [];
//     periods.forEach((x) => {
//       parsedPeriods.push(x);
//     });
//     return parsedPeriods;
//   };
//   OnClickForward = () =>
//     this.state.periodIndex + 1! > this.state.yearFilter.length
//       ? ""
//       : this.setState(
//           (prevState) => ({
//             periodIndex: prevState.periodIndex + 1,
//           }),
//           () => this.FilterByYear(this.state.periodIndex)
//         );

//   OnClickBackward = () =>
//     this.state.periodIndex - 1 <= 0
//       ? ""
//       : this.setState(
//           (prevState) => ({
//             periodIndex: prevState.periodIndex - 1,
//           }),
//           () => this.FilterByYear(this.state.periodIndex)
//         );

//   OnClickHandlerForReportsExpectedBarChart = async (barPeriod: string) => {
//     const dataForPie = await DataService.Dashboard.GetData_ICategoryForPieChart(
//       `${barPeriod}-01`
//     );
//     this.setState({ period: barPeriod, dataForPie });
//   };

//   OnClickHandlerForSelectedSlicePieChart = async (category: any) => {
//     const categorys: { [key: string]: number } = {
//       "El och Fiber": 100,
//       Sinfra: 200,
//       "Tjänster och Konsulter": 300,
//       "Vatten och Avlopp": 400,
//       "Värme och kyla": 500,
//       Övrigt: 900,
//       Ekonomi: 910,
//       "Hamn och Återvinning":600
//     };
//     const res: IInvoiceDataForPieChart[] = [];
//     for (let index = 0; index < this.state.summedDataForPie.length; index++) {
//       if (
//         this.state.summedDataForPie[index].categoryId ===
//           categorys[category.name] &&
//         this.state.summedDataForPie[index].period.includes(this.state.period)
//       ) {
//         res.push(this.state.summedDataForPie[index]);
//       }
//     }
//     this.setState({
//       showCategoryModal: true,
//       dataForCategoryModal: res,
//       selectedCategory: category.name,
//     });
//   };
//   OnCloseHandlerForCategoryModal = () => {
//     this.setState({ showCategoryModal: false });
//   };
//   FilterByYear(index: number) {
//     const result: any[] = [];
//     for (let index = 0; index < this.state.expectedReports.length; index++) {
//       const invoiceReports = this.state.expectedReports[index].invoiceReports;
//       const nullReports = this.state.expectedReports[index].nullReports;
//       const totalExpected = this.state.expectedReports[index].reportsExpected;
//       const csrdReports = this.state.expectedReports[index].csrdReports;
//       if (
//         this.state.expectedReports[index].period.includes(
//           this.state.yearFilter[this.state.periodIndex - 1]
//         )
//       ) {
//         const procentInvoiceReports = RoundTo(
//           (invoiceReports /
//             totalExpected) *
//             100, 1
//         );
//         const procentNullReports = RoundTo(
//           (nullReports /
//             totalExpected) *
//             100, 1
//         );
//         const procentCsrdReports = RoundTo((csrdReports / totalExpected) * 100,1)
//         result.push({
//           period: this.state.expectedReports[index].period,
//           reportsExpected: 100,
//           invoiceReports: procentInvoiceReports,
//           nullReports: procentNullReports,
//           csrdReports: procentCsrdReports,
//           fullyReported: (csrdReports+ invoiceReports + nullReports) >= totalExpected ? 1 : 0,
//           toolTipData: this.state.expectedReports[index],
//         });
//       }
//     }
 
//     this.setState({ filterdByYear: result,loading:false });
//     return result;
//   }
//   render() {
//     console.log(this.state)
//     const categorys: { [key: string]: string } = {
//       "100": "El och Fiber",
//       "200": "Sinfra",
//       "300": "Tjänster och Konsulter",
//       "400": "Vatten och Avlopp",
//       "500": "Värme och kyla",
//       "600" : "Hamn och Återvinning",
//       "900": "Övrigt",
//       "910": "Ekonomi",
//     };
//     const test: { [key: string]: number } =
//       this.state.period.length > 0
//         ? this.state.summedDataForPie.reduce((res: any, item) => {
//             const cat = categorys[`${item.categoryId}`];
//             const sumvalue = Math.round(item.priceExcMoms);
//             if (
//               !res[cat] &&
//               sumvalue > 0 &&
//               item.period.includes(this.state.period)
//             ) {
//               res[cat] = sumvalue;
//             } else if (
//               res[cat] &&
//               sumvalue > 0 &&
//               item.period.includes(this.state.period)
//             ) {
//               res[cat] += sumvalue;
//             }
//             return res;
//           }, {})
//         : {};
//     const compStyles = getComputedStyle(document.documentElement);
//     return (
//       <div  >
//         {this.state.loadingCards ? (
//           <Spinner />
//         ) : (
//           <Stack
//             className="dashboardCardscontainer"
//             gap={3}
//             style={{ marginBottom: "10px" }}
//             direction="horizontal"
//           >
//             <Card
//               backgroundColor={compStyles.getPropertyValue("--statistic-background")}
//               color={compStyles.getPropertyValue("--statistic-color")}
//               svg={SvgForStatisticReports()}
//               cardTitle={i18n.t("dashboard.invoiceReports")}
//               statProcent={this.state.statistikRapporterCard
//                 .reduce((acc, z) => {
//                   return acc + z.totalReported;
//                 }, 0)
//                 .toString()}
//               week={this.state.statistikRapporterCard[0].week}
//               dataPointsTrendline={this.state.statistikRapporterCard}
//             />

//             <Card
//               backgroundColor={compStyles.getPropertyValue("--zero-background")}
//               color={compStyles.getPropertyValue("--zero-color")}
//               svg={SvgForNullReports()}
//               cardTitle={i18n.t("dashboard.nullReports")}
//               statProcent={this.state.nollRapporterCard
//                 .reduce((acc, z) => {
//                   return acc + z.totalReported;
//                 }, 0)
//                 .toString()}
//               week={this.state.nollRapporterCard[0].week}
//               dataPointsTrendline={this.state.nollRapporterCard}
//             />

//             <Card
//               backgroundColor={compStyles.getPropertyValue("--kickback-background")}
//               color={compStyles.getPropertyValue("--kickback-color")}
//               svg={SvgForKickbackReports()}
//               cardTitle={i18n.t("dashboard.kickbackReport")}
//               statProcent={this.state.kickbackRapporterCard
//                 .reduce((acc, z) => {
//                   return acc + z.totalReported;
//                 }, 0)
//                 .toString()}
//               week={this.state.kickbackRapporterCard[0].week}
//               dataPointsTrendline={this.state.kickbackRapporterCard}
//             />
//           </Stack>
//         )}
//         {this.state.loading ? (
//           <div style={{ float: "right", marginLeft: "10px" }}>
//             <Spinner />
//           </div>
//         ) : (
          
//           // <Stack direction="horizontal">
//           <div className="test" >
//           <div className="dashboardChartsscontainer">
//            {/* <Stack  > */}
           
//              <ExpectedReportsBarChart
//                data={this.state.filterdByYear}
//                loading={this.state.loading}
//                onClick={this.OnClickHandlerForReportsExpectedBarChart}
//                onClickForward={this.OnClickForward}
//                onClickBackward={this.OnClickBackward}
//                yearFilter={this.state.yearFilter ?? []}
//                periodIndex={this.state.periodIndex}
//              />
//            {/* </Stack> */}
//              </div>
//           <div className="dashboardPieContainer" >
//             {/* <Stack gap={3}> */}
//               <PieChartCategorys
//                 category={this.state.categorys}
//                 data={test}
//                 period={this.state.period}
//                 onSelectedSlice={this.OnClickHandlerForSelectedSlicePieChart}
//               />
//               <CalendarYearPie data={this.state.aggregatedYear}/>
//             {/* </Stack> */}
//             <Stack>
//               <div style={{alignSelf:'center',paddingTop:'5px'}}>
//                 <ViewCard />
//             </div>
//               </Stack>
//           </div>
          
//           </div>
//             //  </Stack>
//         )}

         
//         {this.state.showCategoryModal && (
//           <CategoryModal
//             onDissmissHandler={this.OnCloseHandlerForCategoryModal}
//             data={this.state.dataForCategoryModal}
//             period={this.state.period}
//             selectedCategory={this.state.selectedCategory}
//             footerSum={test[`${this.state.selectedCategory}`]}
//           />
//         )}
//       </div>
//     );
//   }
// }

// export default withTranslation()(Dashboard);
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable array-callback-return */
import * as React from "react";
import { withTranslation } from "react-i18next";
import i18n from "../i18n";
import { DataService } from "../services/DataService";
import ExpectedReportsBarChart from "../components/DashboardComps/ExpectedReportsBarChart";
import { Spinner, Stack } from "react-bootstrap";
import {
  ICategoryForPieChart,
  IDashboardCategorys,
  IDashboardExpectedReports,
  IData_fordashboardCard,
  IInvoiceDataForPieChart,
} from "../services/API/DashBoard";
import PieChartCategorys from "../components/DashboardComps/PieChartCategorys";
import Card from "../components/DashboardComps/Card";
import {
  SvgForKickbackReports,
  SvgForNullReports,
  SvgForStatisticReports,
} from "../components/DashboardComps/SvgIcons";
import CategoryModal from "../components/DashboardComps/CategoryModal";
import ViewCard from "../components/DashboardComps/ViewCard";
import { RoundTo } from "../lib/utils";
import CalendarYearPie from "../components/DashboardComps/CalendarYearPie";
import AcademicyearModal from "../components/DashboardComps/AcademicyearModal";

interface IDashboardProps {}
interface IDashboardState {
  loading: boolean;
  loadingCards: boolean;
  expectedReports: IDashboardExpectedReports[];
  categorys: IDashboardCategorys;
  period: string;
  statistikRapporterCard: IData_fordashboardCard[];
  nollRapporterCard: IData_fordashboardCard[];
  kickbackRapporterCard: IData_fordashboardCard[];
  periodIndex: number;
  yearFilter: string[];
  showCategoryModal: boolean;
  dataForCategoryModal: any[];
  summedDataForPie: IInvoiceDataForPieChart[];
  dataForPie: ICategoryForPieChart[];
  selectedCategory: string;
  filterdByYear: any[];
  aggregatedYear: AggregatedYear[];
  activePie: "month" | "year"; // <-- NY
  selectedAcademicYear:{period:string,typeOfEvent:string};
  showAcademicyearModal:boolean;
}

type PeriodRow = {
  period: string; // "YYYY-MM"
  reportsExpected: number;
  reportsReceived: number;
  invoiceReports: number;
  nullReports: number;
  csrdReports: number;
};

type AggregatedYear = {
  academicYearKey: string; 
  label: string; 
  reportsExpected: number;
  reportsReceived: number;
};

function getAcademicYearKey(
  period: string,
  startMonth = 9
): { key: string; label: string } {
  const [yearStr, monthStr] = period.split("-");
  const year = parseInt(yearStr, 10);
  const month = parseInt(monthStr, 10);

  if (Number.isNaN(year) || Number.isNaN(month)) {
    throw new Error(`Ogiltig period: ${period}`);
  }

  const startYear = month >= startMonth ? year : year - 1;
  const endYear = startYear + 1;

  return {
    key: `${startYear}-${String(startMonth).padStart(2, "0")}_${endYear}-08`,
    label: `${startYear}/${endYear}`,
  };
}

function aggregateByAcademicYear(
  data: PeriodRow[],
  startMonth = 9
): AggregatedYear[] {
  const map = new Map<string, AggregatedYear>();

  for (const row of data) {
    const { key, label } = getAcademicYearKey(row.period, startMonth);

    if (!map.has(key)) {
      map.set(key, {
        academicYearKey: key,
        label,
        reportsExpected: 0,
        reportsReceived: 0,
      });
    }

    const agg = map.get(key)!;
    agg.reportsExpected += row.reportsExpected;
    agg.reportsReceived += row.reportsReceived;
  }

  const result = Array.from(map.values()).sort((a, b) => {
    const aStartYear = parseInt(a.label.split("/")[0], 10);
    const bStartYear = parseInt(b.label.split("/")[0], 10);
    return aStartYear - bStartYear;
  });

  return result;
}

class Dashboard extends React.Component<IDashboardProps, IDashboardState> {
  constructor(props: IDashboardProps) {
    super(props);
    this.state = {
      expectedReports: [],
      categorys: {} as IDashboardCategorys,
      period: "",
      statistikRapporterCard: [] as IData_fordashboardCard[],
      nollRapporterCard: [] as IData_fordashboardCard[],
      kickbackRapporterCard: [] as IData_fordashboardCard[],
      loading: true,
      periodIndex: -1,
      yearFilter: [""],
      showCategoryModal: false,
      dataForCategoryModal: [],
      loadingCards: true,
      dataForPie: [] as ICategoryForPieChart[],
      summedDataForPie: [] as IInvoiceDataForPieChart[],
      selectedCategory: "",
      filterdByYear: [],
      aggregatedYear: [],
      activePie: "month", // <-- default: månads-pie (kopplad till bar-chart)
      selectedAcademicYear:{period:"",typeOfEvent:""},
      showAcademicyearModal:false
    };
  }

  async componentDidMount(): Promise<void> {
    const [categorys, summedDataForPie, expectedReports] = await Promise.all([
      DataService.Dashboard.GetCategorys(),
      DataService.Dashboard.GetData_IInvoiceDataForPieChart(),
      DataService.Dashboard.GetExpectedReports(),
    ]);

    await this.InitCards();
    await this.InitBarChart(expectedReports);

    const res = aggregateByAcademicYear(expectedReports as unknown as PeriodRow[]);
    const date = new Date();
    const backUpYeah = new Date(date.getFullYear(), date.getMonth() - 1);
    const formatted = backUpYeah.toLocaleDateString("sv-SE").split("-");
    const period = `${formatted[0]}-${formatted[1]}`;

    this.setState(
      {
        categorys,
        period,
        summedDataForPie,
        expectedReports,
        aggregatedYear: res,
      },
      () => this.InitBarChart(this.state.expectedReports)
    );
  }

  InitBarChart = (expectedReports: IDashboardExpectedReports[]) => {
    const yearFilter = this.CreateYearFilter(expectedReports);
    this.FilterByYear(yearFilter.length);
    this.setState({
      yearFilter,
      periodIndex: yearFilter.length,
    });
  };

  InitCards = async () => {
    const cardData = await DataService.Dashboard.GetData_fordashboardCard();
    this.setState({
      loadingCards: false,
      statistikRapporterCard: cardData[0],
      nollRapporterCard: cardData[1],
      kickbackRapporterCard: cardData[2],
    });
  };

  CreateYearFilter = (
    expectedReports: IDashboardExpectedReports[]
  ): string[] => {
    const periods: Set<string> = new Set();
    expectedReports.map((x) =>
      periods.add(new Date(x.period).getFullYear().toString())
    );
    const parsedPeriods: string[] = [];
    periods.forEach((x) => {
      parsedPeriods.push(x);
    });
    return parsedPeriods;
  };

  OnClickForward = () =>
    this.state.periodIndex + 1 > this.state.yearFilter.length
      ? ""
      : this.setState(
          (prevState) => ({
            periodIndex: prevState.periodIndex + 1,
          }),
          () => this.FilterByYear(this.state.periodIndex)
        );

  OnClickBackward = () =>
    this.state.periodIndex - 1 <= 0
      ? ""
      : this.setState(
          (prevState) => ({
            periodIndex: prevState.periodIndex - 1,
          }),
          () => this.FilterByYear(this.state.periodIndex)
        );

  OnClickHandlerForReportsExpectedBarChart = async (barPeriod: string) => {
    const dataForPie = await DataService.Dashboard.GetData_ICategoryForPieChart(
      `${barPeriod}-01`
    );
    this.setState({ period: barPeriod, dataForPie });
  };
  OnClickHandlerForSelctedSliceAcademicYear = async (academicYear:any) => {
      const {name,period} = academicYear
      this.setState({
          selectedAcademicYear:{period,typeOfEvent:name},
          showAcademicyearModal:true
      })
  }
  OnClickHandlerForSelectedSlicePieChart = async (category: any) => {
    const categorys: { [key: string]: number } = {
      "El och Fiber": 100,
      Sinfra: 200,
      "Tjänster och Konsulter": 300,
      "Vatten och Avlopp": 400,
      "Värme och kyla": 500,
      Övrigt: 900,
      Ekonomi: 910,
      "Avfall och Återvinning": 600,
    };
    const res: IInvoiceDataForPieChart[] = [];
    for (let index = 0; index < this.state.summedDataForPie.length; index++) {
      if (
        this.state.summedDataForPie[index].categoryId ===
          categorys[category.name] &&
        this.state.summedDataForPie[index].period.includes(this.state.period)
      ) {
        res.push(this.state.summedDataForPie[index]);
      }
    }
    this.setState({
      showCategoryModal: true,
      dataForCategoryModal: res,
      selectedCategory: category.name,
    });
  };

  OnCloseHandlerForCategoryModal = () => {
    this.setState({ showCategoryModal: false });
  };
  OnCloseHandlerForAcademicyearModal = () => {
    this.setState({showAcademicyearModal:false})
  }
  FilterByYear(index: number) {
    const result: any[] = [];
    for (let i = 0; i < this.state.expectedReports.length; i++) {
      const item = this.state.expectedReports[i];
      const invoiceReports = item.invoiceReports;
      const nullReports = item.nullReports;
      const totalExpected = item.reportsExpected;
      const csrdReports = item.csrdReports;

      if (item.period.includes(this.state.yearFilter[this.state.periodIndex - 1])) {
        const procentInvoiceReports = RoundTo(
          (invoiceReports / totalExpected) * 100,
          1
        );
        const procentNullReports = RoundTo(
          (nullReports / totalExpected) * 100,
          1
        );
        const procentCsrdReports = RoundTo(
          (csrdReports / totalExpected) * 100,
          1
        );
        result.push({
          period: item.period,
          reportsExpected: 100,
          invoiceReports: procentInvoiceReports,
          nullReports: procentNullReports,
          csrdReports: procentCsrdReports,
          fullyReported:
            csrdReports + invoiceReports + nullReports >= totalExpected ? 1 : 0,
          toolTipData: item,
        });
      }
    }

    this.setState({ filterdByYear: result, loading: false });
    return result;
  }

  render() {
    const categorys: { [key: string]: string } = {
      "100": "El och Fiber",
      "200": "Sinfra",
      "300": "Tjänster och Konsulter",
      "400": "Vatten och Avlopp",
      "500": "Värme och kyla",
      "600": "Avfall och Återvinning",
      "900": "Övrigt",
      "910": "Ekonomi",
    };

    const test: { [key: string]: number } =
      this.state.period.length > 0
        ? this.state.summedDataForPie.reduce((res: any, item) => {
            const cat = categorys[`${item.categoryId}`];
            const sumvalue = Math.round(item.priceExcMoms);
            if (
              !res[cat] &&
              sumvalue > 0 &&
              item.period.includes(this.state.period)
            ) {
              res[cat] = sumvalue;
            } else if (
              res[cat] &&
              sumvalue > 0 &&
              item.period.includes(this.state.period)
            ) {
              res[cat] += sumvalue;
            }
            return res;
          }, {})
        : {};

    const compStyles = getComputedStyle(document.documentElement);

    return (
      <div>
        {this.state.loadingCards ? (
          <Spinner />
        ) : (
          <Stack
            className="dashboardCardscontainer"
            gap={3}
            style={{ marginBottom: "10px" }}
            direction="horizontal"
          >
            <Card
              backgroundColor={compStyles.getPropertyValue(
                "--statistic-background"
              )}
              color={compStyles.getPropertyValue("--statistic-color")}
              svg={SvgForStatisticReports()}
              cardTitle={i18n.t("dashboard.invoiceReports")}
              statProcent={this.state.statistikRapporterCard
                .reduce((acc, z) => acc + z.totalReported, 0)
                .toString()}
              week={this.state.statistikRapporterCard[0].week}
              dataPointsTrendline={this.state.statistikRapporterCard}
            />

            <Card
              backgroundColor={compStyles.getPropertyValue("--zero-background")}
              color={compStyles.getPropertyValue("--zero-color")}
              svg={SvgForNullReports()}
              cardTitle={i18n.t("dashboard.nullReports")}
              statProcent={this.state.nollRapporterCard
                .reduce((acc, z) => acc + z.totalReported, 0)
                .toString()}
              week={this.state.nollRapporterCard[0].week}
              dataPointsTrendline={this.state.nollRapporterCard}
            />

            <Card
              backgroundColor={compStyles.getPropertyValue(
                "--kickback-background"
              )}
              color={compStyles.getPropertyValue("--kickback-color")}
              svg={SvgForKickbackReports()}
              cardTitle={i18n.t("dashboard.kickbackReport")}
              statProcent={this.state.kickbackRapporterCard
                .reduce((acc, z) => acc + z.totalReported, 0)
                .toString()}
              week={this.state.kickbackRapporterCard[0].week}
              dataPointsTrendline={this.state.kickbackRapporterCard}
            />
          </Stack>
        )}

        {this.state.loading ? (
          <div style={{ float: "right", marginLeft: "10px" }}>
            <Spinner />
          </div>
        ) : (
          <div className="test">
            <div className="dashboardChartsscontainer">
              <ExpectedReportsBarChart
                data={this.state.filterdByYear}
                loading={this.state.loading}
                onClick={this.OnClickHandlerForReportsExpectedBarChart}
                onClickForward={this.OnClickForward}
                onClickBackward={this.OnClickBackward}
                yearFilter={this.state.yearFilter ?? []}
                periodIndex={this.state.periodIndex}
              />
            </div>

            <div className="dashboardPieContainer">
              {/* Header med dropdown för att välja pie-typ */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "4px",
                }}
              >
                <select
                  value={this.state.activePie}
                  onChange={(e) =>
                    this.setState({
                      activePie: e.target.value as "month" | "year",
                    })
                  }
                  style={{
                    fontSize: "0.8rem",
                    padding: "2px 6px",
                    borderRadius: 4,
                    border: "1px solid #e5e7eb",
                    backgroundColor: "#ffffff",
                  }}
                >
                  <option value="month">
                    {i18n.t("dashboard.pie.monthly") || "Inrapporterat per kategori (månad)"}
                  </option>
                  <option value="year">
                    {i18n.t("dashboard.pie.academicYear") || "Rapporteringsöversikt (år)"}
                  </option>
                </select>
              </div>

              {/* Själva pie-yta – togglar mellan två olika komponenter */}
              {this.state.activePie === "month" ? (
                <PieChartCategorys
                  category={this.state.categorys}
                  data={test}
                  period={this.state.period}
                  onSelectedSlice={this.OnClickHandlerForSelectedSlicePieChart}
                />
              ) : (
                <CalendarYearPie data={this.state.aggregatedYear} onSelectedSlice={this.OnClickHandlerForSelctedSliceAcademicYear}/>
              )}

              <Stack>
                <div
                  style={{ alignSelf: "center", paddingTop: "5px" }}
                >
                  <ViewCard />
                </div>
              </Stack>
            </div>
          </div>
        )}

        {this.state.showCategoryModal && (
          <CategoryModal
            onDissmissHandler={this.OnCloseHandlerForCategoryModal}
            data={this.state.dataForCategoryModal}
            period={this.state.period}
            selectedCategory={this.state.selectedCategory}
            footerSum={test[`${this.state.selectedCategory}`]}
          />
        )}
        {this.state.showAcademicyearModal && (
          <AcademicyearModal onDissmissHandler={this.OnCloseHandlerForAcademicyearModal} selectedAcademicYear={this.state.selectedAcademicYear}/>
        )}
      </div>
    );
  }
}

export default withTranslation()(Dashboard);
